import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/window/login' //  /login  /window/login
  },
  // {
  //   path: '/login',
  //   component: () => import('@/views/login/LoginView')
  // },

  // {
  //   path: '/home',
  //   component: () => import('@/views/home/HomeView'),
  //   redirect: '/welcome',
  //   children: [
  //     {
  //       path: '/welcome',
  //       component: () => import('@/views/welcome/WelcomeView'),
  //       meta: {
  //         requireAuth: true,
  //         nav: '欢迎页'
  //       }
  //     },
  //     {
  //       path: '/query',
  //       component: () => import('@/views/query/queryView')
  //     },
  //     {
  //       path: '/datauserView',
  //       component: () => import('@/views/datauser/DatauserView')
  //     }
  //   ]
  // },

  {
    path: '/errorview',
    component: () => import('@/views/base/ErrorView')
  },

  // Android 直接调用
  {
    path: '/window/login',
    component: () => import('@/views/customer/WindowLogin')
  },
  {
    path: '/window/main',
    component: () => import('@/views/customer/WindowMain'),
    redirect: '/window/welcome',
    children: [
      {
        path: '/window/welcome',
        component: () => import('@/views/welcome/WelcomeView'),
        meta: {
          requireAuth: true,
          nav: '欢迎页'
        }
      },
      {
        path: '/window/query',
        component: () => import('@/views/query/queryView')
      },
      {
        path: '/window/base',
        component: () => import('@/views/base/BaseAndroid') // BaseAndroid
      },

      // 新快

      // APP
      {
        path: '/window/app/basemasterdetail',
        component: () => import('@/views/customer/app/BaseMasterDetail')
      },
      {
        path: '/window/app/w_cpck',
        component: () => import('@/views/customer/app/WinCpck')
      },
      // 村田
      {
        path: '/window/cuntianmian/w_cpap_zhcx',
        component: () => import('@/views/customer/cuntianmian/w_cpap_zhcx')
      },
      // 聚隆
      {
        path: '/window/julong/cpck',
        component: () => import('@/views/customer/julong/WinCpck')
      },
      {
        path: '/window/julong/baseCustomer',
        component: () => import('@/views/customer/julong/WinBaseCustomer')
      },

      // 俊翔
      // {
      //   path: '/window/junxiang/mscpin',
      //   component: () => import('@/views/customer/junxiang/WinMsCpin')
      // },
      // {
      //   path: '/window/junxiang/mscpout',
      //   component: () => import('@/views/customer/junxiang/WinMsCpout')
      // },
      // {
      //   path: '/window/junxiang/jeanpbmx',
      //   component: () => import('@/views/customer/junxiang/WinJeanPbmx')
      // },

      // 骏业
      {
        path: '/window/junye/cpck',
        component: () => import('@/views/customer/junye/WinCpck')
      },

      // 新快
      {
        path: '/window/xinkuai/pbkrft',
        component: () => import('@/views/customer/xinkuai/WinPbrkFt')
      },

      // 利致
      {
        path: '/window/lizhi/WinJeanCostZhcx',
        component: () => import('@/views/customer/lizhi/WinJeanCostZhcx')
      },

      // 布行
      {
        path: '/window/buhang/cpck',
        component: () => import('@/views/customer/buhang/WinCpck')
      }

    ]
  }
  // Android 直接调用 结束

]

// 避免重复路由  new VueRouter前
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

// new VueRouter ***
const router = new VueRouter({
  routes
})

// 路由守卫(router/index.js)
router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    return next(to.path)
    // return next('/errorview')
  }

  // 登录界面
  if (to.path == '/login') {
    window.sessionStorage.removeItem('token')
    window.sessionStorage.removeItem('userlist')
    window.sessionStorage.removeItem('querylist')
    window.sessionStorage.removeItem('logintime')
    return next()
  }
  if (to.path == '/window/login') {
    window.sessionStorage.removeItem('token')
    window.sessionStorage.removeItem('userlist')
    window.sessionStorage.removeItem('querylist')
    window.sessionStorage.removeItem('logintime')
    return next()
  }

  if (to.path.indexOf('/window/') != -1) {
    const token = window.sessionStorage.getItem('token')
    const logintem = window.sessionStorage.getItem('logintime')
    const ldt_dt = new Date().getTime() / 1000

    if (!token) {
      window.sessionStorage.removeItem('token')
      window.sessionStorage.removeItem('userlist')
      window.sessionStorage.removeItem('querylist')
      window.sessionStorage.removeItem('logintime')
      return next('/window/login')
    } else {
      return next()
    }
  } else {
    const token = window.sessionStorage.getItem('token')
    const logintem = window.sessionStorage.getItem('logintime')
    const ldt_dt = new Date().getTime() / 1000

    if (!token) { // || ldt_dt - logintem > 9000
      window.sessionStorage.removeItem('token')
      window.sessionStorage.removeItem('userlist')
      window.sessionStorage.removeItem('querylist')
      window.sessionStorage.removeItem('logintime')
      return next('/login')
    } else {
      return next()
    }
  }
})

export default router
